import lodash from "lodash";

export const mergeResponseState = (
	state,
	entities,
	entityName,
	idIndexName = null
) => {
	if (!entityName) {
		throw new Error("You must pass a valid entityName string");
	}
	if (!entities) {
		throw new Error("You must pass a non-empty entities object");
	}
	const entityById = entities[entityName];

	let idIndex = {};

	if (entityById) {
		if (entityById.length === 0) {
			return state;
		}
		const ids = Object.keys(entityById);

		if (idIndexName) {
			idIndex = { [idIndexName]: ids };
		}

		return lodash.merge(
			{},
			state,
			{
				byId: entityById,
				allIds: lodash.concat(state.allIds, ids)
			},
			idIndex
		);
	}

	if (idIndexName) {
		idIndex = { [idIndexName]: null };
	}

	return lodash.merge(
		{},
		state,
		{
			byId: state.byId,
			allIds: state.allIds
		},
		idIndex
	);
};

export const initialEntityState = {
	byId: {},
	allIds: []
};
